import { getRequest, postRequest, deleteRequest } from './api';

const mediaApi = {
  async getMedia(campaignId) {
    if (!campaignId) {
      throw new Error('Campaign ID is required');
    }
    const response = await getRequest(`/api/campaigns/${campaignId}/media`);
    return response;
  },

  async uploadMedia(campaignId, files) {
    if (!campaignId) {
      throw new Error('Campaign ID is required');
    }
    // Accept both a single file and an array of files
    const fileArray = Array.isArray(files) ? files : [files];
    const formData = new FormData();
    fileArray.forEach((file) => {
      formData.append('files', file);
    });
    const response = await postRequest(`/api/campaigns/${campaignId}/media`, formData, {
      'Content-Type': 'multipart/form-data'
    });
    return response;
  },

  async deleteMedia(campaignId, mediaId) {
    if (!campaignId || !mediaId) {
      throw new Error('Campaign ID y Media ID son requeridos');
    }
    const response = await deleteRequest(`/api/campaigns/${campaignId}/media/${mediaId}`);
    return response;
  },

  async getLogo(campaignId) {
    if (!campaignId) {
      throw new Error('Campaign ID is required');
    }
    const response = await getRequest(`/api/campaigns/${campaignId}/logo`);
    return response;
  },

  // method for uploading logo
  async uploadLogo(campaignId, file) {
    // route is /api/campaigns/<int:campaign_id>/logo
    if (!campaignId) {
      throw new Error('Campaign ID is required');
    }
    const formData = new FormData();
    formData.append('file', file);
    const response = await postRequest(`/api/campaigns/${campaignId}/logo`, formData, {
      'Content-Type': 'multipart/form-data'
    });
    return response;
  },

  // method for deleting logo
  async deleteLogo(campaignId) {
    if (!campaignId) {
      throw new Error('Campaign ID is required');
    }
    const response = await deleteRequest(`/api/campaigns/${campaignId}/logo`);
    return response;
  }
}

export default mediaApi;
